<template>
	<div class="mdx-list-header">
		<div class="mdx-list-header__wrapper" :clas="{'has-subtitle': subtitle}">
			<div class="mdx-list-header__wrapper__left" :class="{ 'has-back': allowBack }">
				<a @click.prevent="onGoBack ? onGoBack : $router.go(-1)" class="mdx-list-header__wrapper__left__link" v-if="allowBack">
					<div class="mdx-list-header__wrapper__left__link__img">
						<img :src="iconBack" />
					</div>
					<span>{{ $t('Späť') }}</span>
				</a>
			</div>
			<div class="mdx-list-header__wrapper__right">
				<template v-if="!title">
					<div class="skelet h-[35px] w-[100px]"></div>
				</template>

				<template v-else>
					<h1 v-if="boldTitle"><b>{{ title }}</b></h1>
					<h1 v-else>{{ title }}</h1>
				</template>

				<div class="mdx-list-header__wrapper__right__warning" v-if="insuranceDebt">
					<img :src="iconWarning" >
					<span>{{ $t('DLŽNÍK') }}</span>
				</div>
				<div class="mdx-list-header__wrapper__right__warning" v-if="expiredDocs">
					<img :src="iconWarning" >
					<span>{{ $t('EXSPIROVANÉ DOKUMENTY') }}</span>
				</div>
			</div>

			<h3 v-if="subtitle">{{ subtitle }}</h3>
		</div>

		<div class="mdx-list-header__right">
			<slot name="action-button" />
		</div>
	</div>
</template>

<script>
import iconBack from './_assets/arrow-back.svg'
import iconWarning from './_assets/icon-warning.svg'

export default {
	props: {
		title: {
			type: [String, null],
			required: true
		},

		subtitle: {
			type: [String, null],
			default: null
		},

		boldTitle: {
			type: Boolean,
			default: false
		},

		allowBack: {
			type: Boolean,
			default: true
		},

		onGoBack: {
			type: [Function, null],
			default: null
		},

		insuranceDebt: {
			type: Boolean,
			default: false
		},

		expiredDocs: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			iconBack: iconBack,
			iconWarning
		}
	}
}
</script>

<style lang="sass" scoped>
@import '@/plugins/app/theme/_mixins/responsive.mixin'
.mdx-list-header
	@apply min-h-[101px] px-[65px] mb-[20px] flex justify-between max-md:block border-b-[1px]

	&__wrapper
		@apply max-md:mb-[17px] flex flex-col mt-[37px]

		&:not(.has-subtitle)
			@apply pb-[20px]

		&__left
			@apply flex items-center cursor-pointer

			&.has-back
				@apply mb-[17px]

			&__link
				@apply flex items-center

				&__img
					@apply mr-[10px]
		&__right
			@apply flex gap-[10px] items-center flex-wrap

			&__warning
				@apply bg-[#CD7E35]  px-[10px] py-[5px] flex rounded-[3px]

				span
					@apply text-white text-[11px] font-bold leading-[23px] ml-2

		h1
			@apply min-h-[35px]

		h3
			@apply mb-[20px] mt-2

	&__right
		@apply flex items-end items-center max-md:block gap-[5px]

		:deep(ion-button)
			text-transform: none
			font-size: 14px
			font-weight: 600

	+md
		@apply min-h-[auto] py-[15px] px-[16px]

		&__wrapper
			@apply my-0 mb-[10px]

			h1
				font-size: 22px
			h3
				@apply text-base

	+md-height
		@apply min-h-[70px]

		&__wrapper
			@apply mt-[25px]

			h1
				font-size: 24px
</style>
